import { createFetchAction } from '../utils';
import * as orderActionTypes from './orderActionTypes';

export const fetchOrderActions = createFetchAction(orderActionTypes.FETCH_ORDER_ACTIONS, 'orderActionId');
